import { api } from "@/api/axios.ts";
import { ApiOperationResult, ApiFile } from "@/types/common.types.ts";
import { AxiosProgressEvent } from "axios";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiFormView } from "@/types/forms/form-view.types.ts";
import { ApiFormResultAnswer } from "@/types/forms/form.types.ts";
import {
  ApiSurveyParticipantView,
  ApiSurveyParticipantViewFilter,
  ApiSurveyRespond,
} from "@/types/survey.types.ts";

export const apiEmployeeSurvey = {
  searchParticipantViews: async function (
    employeeId: number,
    filter: ApiSurveyParticipantViewFilter,
    signal: AbortSignal
  ) {
    return api.post<ApiPagedData<ApiSurveyParticipantView>>(
      `/api/v1/employees/${employeeId}/surveys/participant/search`,
      filter,
      signal
    );
  },
  getById: async function (employeeId: number, surveyId: number) {
    return api.get<ApiSurveyRespond>(`/api/v1/employees/${employeeId}/surveys/${surveyId}`);
  },
  getForm: async function (employeeId: number, surveyId: number) {
    return api.get<ApiFormView>(`/api/v1/employees/${employeeId}/surveys/${surveyId}/form`);
  },
  uploadAnswerFile: async function (
    employeeId: number,
    surveyId: number,
    formElementId: number,
    file: File,
    onUploadProgress?: (event: AxiosProgressEvent) => void
  ) {
    const data = new FormData();
    data.append("file", file);

    return api.post<ApiFile>(
      `/api/v1/employees/${employeeId}/surveys/${surveyId}/form-elements/${formElementId}/files`,
      data,
      undefined,
      { onUploadProgress }
    );
  },
  deleteAnswerFile: async function (
    employeeId: number,
    surveyId: number,
    formElementId: number,
    fileUuid: string
  ) {
    return api.delete<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/surveys/${surveyId}/form-elements/${formElementId}/files/${fileUuid}`
    );
  },
  saveDraft: async function (employeeId: number, surveyId: number, data: ApiFormResultAnswer[]) {
    return api.put<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/surveys/${surveyId}/results`,
      data
    );
  },
  submitResults: async function (
    employeeId: number,
    surveyId: number,
    data: ApiFormResultAnswer[]
  ) {
    return api.post<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/surveys/${surveyId}/results`,
      data
    );
  },
};
